function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".step_1_svg__a{fill:#a59bc3}.step_1_svg__c{fill:#eae9ef}.step_1_svg__d{fill:#614cb4}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "step_1_svg__a",
  d: "M30.138 16.739a7 7 0 117-7 7 7 0 01-7 7zm0-13.751a6.755 6.755 0 106.755 6.755 6.755 6.755 0 00-6.755-6.755zM101.057 16.739a7 7 0 117-7 7 7 0 01-7 7zm0-13.751a6.755 6.755 0 106.755 6.755 6.755 6.755 0 00-6.755-6.755z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M126.672.501H4.798c-2.373 0-4.3 2.379-4.3 5.311v58.1c0 2.931 1.926 5.305 4.3 5.311h121.874c2.373 0 4.3-2.379 4.3-5.311v-58.1c0-2.931-1.926-5.305-4.3-5.311zm3.793 63.415c0 2.587-1.7 4.683-3.793 4.686H4.798c-2.094 0-3.79-2.1-3.793-4.686v-58.1c0-2.587 1.7-4.683 3.793-4.686h121.874c2.094 0 3.79 2.1 3.793 4.686z",
  fill: "rgba(165,155,195,.56)",
  stroke: "rgba(165,155,195,.9)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "step_1_svg__c",
  d: "M9.432 23.871h21.655v15.158H9.432zM39.749 23.871h21.655v15.158H39.749zM70.065 23.871H91.72v15.158H70.065zM100.382 23.871h21.655v15.158h-21.655zM9.432 46.067h21.655v15.158H9.432zM39.749 46.067h21.655v15.158H39.749zM70.065 46.067H91.72v15.158H70.065zM100.382 46.067h21.655v15.158h-21.655z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "step_1_svg__d",
  d: "M46.962 61.137l-5.112-7.06 1.392-1.008 3.913 5.4 14.973-15.383 1.232 1.2zM77.55 38.941l-5.112-7.06 1.392-1.008 3.913 5.4L92.716 20.89l1.232 1.2z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "step_1_svg__a",
  d: "M29.86.501h.37v9.273h-.37zM101.049.501h.37v9.273h-.37z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "step_1_svg__d",
  d: "M16.917 38.941l-5.112-7.06 1.392-1.008 3.913 5.4L32.083 20.89l1.232 1.2z"
});

function SvgStep1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 131.47 69.727",
    className: "w-full h-full"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

export default SvgStep1;